import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResultStatusResponseModel } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ResultStatusResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ResultStatusResponseModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const reset: CaseReducer<SliceState> = () => ({
  ...initState,
});

const resultStatusSlice = createSlice({
  name: 'resultStatus',
  initialState: initState,
  reducers: {
    reset,
    setLoading,
    setData,
    setError,
  },
});

export default resultStatusSlice;
